import HexCoords from "./HexCoords";

const HexBuilder = {}

HexBuilder.buildRectangle = function(xSize, ySize, callback) {
  var currentRow = 0;
  var currentCol = 0;

  while (currentRow < ySize) {
    while (currentCol < xSize) {
      let offset = 0;

      if (currentRow % 2 == 0) {
        offset = currentRow / 2;
      } else {
        offset = (currentRow - 1) / 2;
      }

      let hc = HexCoords.get([currentCol - offset, currentRow]);
      callback(hc)
      currentCol += 1;
    }
    currentCol = 0;
    currentRow += 1;
  }
  return grid;
};


export default HexBuilder;
